import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const incidentsBaseUrl = '/api/incidents';
export const incidentsApi = createApi({
  reducerPath: 'incidentsApi',
  baseQuery: customBaseQuery,
  tagTypes: ['Incident'],
  endpoints: (builder) => ({
    getIncidents: builder.query<Incident[] | Incident, number | void>({
      query: (id) => ({
        url: incidentsBaseUrl,
        params: id ? { id } : undefined,
      }),
      providesTags: (_result, _error, id) =>
        id ? [{ type: 'Incident', id }, 'Incident'] : ['Incident'],
    }),
    getIncidentsByRequest: builder.query<IncidentsByRequestResponse[], string | null>({
      query: (token) => ({
        url: `${incidentsBaseUrl}/by-request`,
        method: 'GET',
        params: { access_token: token },
      }),
      providesTags: ['Incident'],
    }),
  }),
});

export const { useGetIncidentsQuery, useGetIncidentsByRequestQuery } = incidentsApi;
